import React, { Component } from 'react';
import Axios from 'axios';
import moment from 'moment';
import service from './service';
import LoadingTable from '../../Component/LoadingTable';

class Birthday extends Component {
    constructor(props) {
        super(props);
        this.state = {
            employees : [],
            isLoaded : false,
        }
    }

    signal = Axios.CancelToken.source();

    componentDidMount(){
        service.getEmployeeBirthday().then((res) => this.setState({employees:[...res.data.result],isLoaded:true}));
    }

    componentWillUnmount(){
        // Interrupt API call when component will unmount
        this.signal.cancel("API call has been canceled");
    }

    render (){
        return (
            <div>
                <h4 className="inline">Birthday</h4>
                <div className="table-responsive m-t-10">
                    <table className="table table-hover mails m-0">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Birthday Date</th>
                                <th>Birthday</th>
                            </tr>
                        </thead>
                        <tbody>
                            {      
                                this.state.isLoaded ? this.state.employees.map((e,index) => 
                                <tr key={ index } style={{ cursor:'pointer' }}>
                                    <td>{ e.name }</td>
                                    <td>{ e.birth_date ? moment(e.birth_date).format("D MMM ") : '-' }{ moment().format("YYYY") }</td>
                                    <td>{ e.birth_date ? 1+moment().diff(e.birth_date, 'years',false) : '-'}</td>
                                </tr>
                                ) : <LoadingTable colspan="3" />
                            }
                        </tbody>
                    </table>              
                </div>
            </div>
        )
    }
}

export default Birthday;